import { Typography, Box } from "@mui/material";
import ExecutionEvent from "./ExecutionEvent";
import MessageEvent from "./MessageEvent";

interface EventsListProps {
  messages: string[];
  executions: Array<{
    model: string;
    latencySeconds: number;
    inputMessageCount: number;
    metadataJson: string;
  }>;
}

interface CombinedEvent {
  type: "message" | "execution";
  data: any;
  originalIndex: number;
}

export default ({ messages, executions }: EventsListProps) => {
  const combinedEvents: CombinedEvent[] = [];

  // Add all messages
  messages.forEach((message: string, index: number) => {
    combinedEvents.push({
      type: "message",
      data: message,
      originalIndex: index,
    });
  });

  // Insert executions at the right positions based on inputMessageCount
  executions.forEach((execution: any, execIndex: number) => {
    const insertAfterMessage = execution.inputMessageCount;
    // Find the position to insert this execution
    let insertIndex = combinedEvents.findIndex(
      (event) =>
        event.type === "message" && event.originalIndex >= insertAfterMessage,
    );

    if (insertIndex === -1) {
      // Insert at the end if no message found
      insertIndex = combinedEvents.length;
    }

    combinedEvents.splice(insertIndex, 0, {
      type: "execution",
      data: execution,
      originalIndex: execIndex,
    });
  });

  if (combinedEvents.length === 0) {
    return (
      <Typography color="textSecondary">
        No messages or executions found for this thread.
      </Typography>
    );
  }

  return (
    <Box>
      {combinedEvents.map((event, combinedIndex) => {
        if (event.type === "execution") {
          return (
            <ExecutionEvent
              key={`execution-${combinedIndex}`}
              execution={event.data}
              index={event.originalIndex}
              combinedIndex={combinedIndex}
            />
          );
        } else {
          return (
            <MessageEvent
              key={`message-${combinedIndex}`}
              eventString={event.data}
              index={event.originalIndex}
              combinedIndex={combinedIndex}
            />
          );
        }
      })}
    </Box>
  );
};
